import {
  GET_USER,
  RESET_USER,
  NO_USER_FOUND,
  USER_IS_LOADING,
  PROGRESS_UPLOADING_PERCENTAGE,
} from '../actions/types';

import {User} from '../../graphql/API';

export const initialState: UserState = {
  user: null,
  isLoading: false,
  error: null,
  uploadingProgress: 0,
  isLoggedIn: false,
};

export type UserState = {
  user: User;
  isLoading: boolean;
  error: null | any;
  uploadingProgress: number;
  isLoggedIn: boolean;
};

const user = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_USER:
      console.log('state', state);
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        isLoading: false,
        error: null,
      };

    case NO_USER_FOUND:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        isLoading: false,
        error: null,
      };
    case RESET_USER:
      return {
        ...state,
        isLoading: false,
        user: null,
        isLoggedIn: false,
      };
    case USER_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }

    case PROGRESS_UPLOADING_PERCENTAGE: {
      return {
        ...state,
        uploadingProgress: action.payload,
      };
    }

    default:
      return state;
  }
};

export default user;
